'use strict';

function numberWithCommas(n) {
    return n.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

function convertToImperial (measurement, type) {
  var conversionFactors = {
    distance: 3.2808,
    area: 10.7639,
    volume: 1.30795
  };

  return numberWithCommas(measurement * conversionFactors[type]);
}

module.exports = {

  /**
   * getLabel - returns label for various types of measurements in metric or imperial units
   *
   * @param  {Number} measurement the calculated measurement in metric units
   * @param  {String} units       'imperial' or 'metric'
   * @param  {String} type        type of measurement - 'distance', 'area', or 'volume'
   * @return {String}             measurement, converted to imperial if necessary,
   */
  getLabel: function getLabel (measurement, type, units) {
    units = units || 'metric';

    var labels = {
      distance: {
        imperial: 'ft',
        metric: 'm'
      },
      area: {
        imperial: 'ft\u00B2',
        metric: 'm\u00B2'
      },
      volume: {
        imperial: 'yd\u00B3',
        metric: 'm\u00B3'
      }
    };
    var label = labels[type][units];

    if (units === 'imperial') {
      return [convertToImperial(measurement, type), label].join(' ');
    }

    return [numberWithCommas(measurement), label].join(' ');
  }
};



// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/map/src/app/layer/utils/LabelConverter.js